export const Util = Object.freeze({
    /**Agrega la parte a la cadena dejando las partes anteriores con coma y esta última con "y" */
    agregarACadenaConComa(cadena, parte) {
        if (!cadena) cadena += parte;
        else {
            // Reemplazar última "y" por una coma
            cadena = cadena.replace(" y ", ", ");

            // Esta es la última parte, poner "y"
            cadena += " y " + parte;
        }

        return cadena;
    },
    /** Devuelve una copia profunda del objeto */
    copiaProfunda(objeto) {
        return JSON.parse(JSON.stringify(objeto));
    },
    /** Devuelve elemento aleatorio del arreglo */
    elementoAleatorio(arreglo) {
        let indice = Math.floor(Math.random() * arreglo.length);
        return arreglo[indice];
    },
    /**
     * Elimina el elemento del arreglo
     * @param {Array<*>} arreglo Arreglo que contiene el elemento
     * @param {*} elemento Elemento a eliminar
     */
    eliminarElemento(arreglo, elemento) {
        this.eliminarEn(arreglo, arreglo.indexOf(elemento));
    },
    /** Elimina el item en la posición indicada del arreglo 
     * @param {Array<*>} arreglo
     * @param {Number}  indice
    */
    eliminarEn(arreglo, indice) {
        arreglo.splice(indice, 1);
    },
    Fecha: {
        /**
         * Diferencia en días entre las dos fechas, devuelve 
         * valor decimal
         * @param {Date} viejaFecha fecha más antigua
         * @param {Date} nuevaFecha fecha más reciente, hoy si no se pasa un valor
         */
        diasDeDiferencia(viejaFecha, nuevaFecha = new Date()) {
            // Un día en milisegundos
            const unDiaMs = 1000 * 60 * 60 * 24;

            // Fechas en milisegundos
            const nuevaMs = nuevaFecha.getTime();
            const viejaMs = viejaFecha.getTime();

            const diferenciaMs = nuevaMs - viejaMs;

            // Dividir diferencia en milisegundos por la cantidad de 
            // milisegundos que hay en un día
            return diferenciaMs / unDiaMs;
        }
    },
    formatMoney(value) {
        var formatter = new Intl.NumberFormat(
            'es-AR',
            {
                style: "currency",
                currency: "ARS",
                minimumFractionDigits: 2,
            }
        );

        return formatter.format(value);
    },
    /**
     * Devuelve desde qué elemento se debe pedir al server teniendo en cuenta la página actual
     * @param {number} pagina número de página 
     * @param {number} cantidadPorPagina cantidad de elementos por página
     * @returns 
     */
    paginacionCalcularDesde(pagina, cantidadPorPagina) {
        if (pagina <= 0) return 1;
        return (pagina - 1) * cantidadPorPagina + 1;
    },
    /**
     * Devuelve hasta qué elemento se debe pedir al server teniendo en cuenta la página actual
     * @param {number} pagina número de página 
     * @param {number} cantidadPorPagina cantidad de elementos por página
     * @returns 
     */
    paginacionCalcularHasta(pagina, cantidadPorPagina) {
        return pagina * cantidadPorPagina;
    },
    /**
     * Hace un scroll hacia el elemento cuyo id es el pasado
     * @param {*} idElemento id del elemento al que se quiere scrollear
     * @param {*} suave verdadero si se quiere un scroll suave, falso si se quiere instantaneo
     */
    scrollearAId(idElemento, suave = false) {
        document
            .getElementById(idElemento)
            .scrollIntoView({ behavior: suave ? "smooth" : "auto" });
    },
})